{
  "status": {
    "pending": "รอผล",
    "preliminary": "ผลเบื้องต้น",
    "final": "ผลสุดท้าย",
    "corrected": "ผลแก้ไข",
    "amended": "ผลเพิ่มเติม",
    "addended": "มีภาคผนวก",
    "enteredInError": "บันทึกผิด",
    "unknown": "ไม่ทราบ"
  },
  "review": {
    "title": "ทบทวนผลตรวจ",
    "printLabel": "พิมพ์ผลตรวจ",
    "summary": {
      "count_one": "{{count}} ผลตรวจ",
      "count_other": "{{count}} ผลตรวจ",
      "criticalUnacknowledged": "ค่าวิกฤตยังไม่รับทราบ {{count}} รายการ"
    },
    "view": {
      "timeline": "ไทม์ไลน์",
      "flowsheet": "ตารางผล"
    },
    "filter": {
      "date": "วันที่",
      "type": "ประเภท",
      "status": "สถานะ",
      "statusAll": "ทั้งหมด"
    },
    "dateRange": {
      "h24": "24 ชม. ที่ผ่านมา",
      "h48": "48 ชม. ที่ผ่านมา",
      "d7": "7 วันที่ผ่านมา",
      "d30": "30 วันที่ผ่านมา",
      "all": "ทั้งหมด"
    },
    "resultType": {
      "all": "ทั้งหมด",
      "lab": "ห้องปฏิบัติการ",
      "imaging": "ภาพวินิจฉัย",
      "pathology": "พยาธิวิทยา",
      "cardiology": "หัวใจ",
      "microbiology": "จุลชีววิทยา"
    },
    "criticalOnlyToggle": "แสดงเฉพาะค่าวิกฤต",
    "criticalBadge": "วิกฤต",
    "actions": {
      "acknowledgeCritical": "รับทราบค่าวิกฤต",
      "acknowledgeAllCritical": "รับทราบผลวิกฤตทั้งหมด ({{count}})"
    },
    "detail": {
      "resultNumber": "เลขที่ผลตรวจ",
      "performingProviderId": "รหัสผู้ตรวจ",
      "verifiedByProviderId": "รหัสผู้ยืนยัน",
      "verifiedAt": "เวลายืนยัน",
      "specimenCollected": "เวลาเก็บตัวอย่าง",
      "clinicalSignificance": "ความสำคัญทางคลินิก",
      "recommendations": "ข้อแนะนำ",
      "report": "รายงาน",
      "addendum": "ภาคผนวก",
      "criticalAcknowledged": "รับทราบค่าวิกฤตแล้ว",
      "providerHash": "ผู้ตรวจ #{{id}}",
      "acknowledgedAt": " เมื่อ {{when}}",
      "specimenType": "ชนิดสิ่งส่งตรวจ",
      "grossDescription": "ลักษณะทางมหกายวิภาค",
      "microscopicDescription": "ลักษณะทางจุลกายวิภาค",
      "accessionNumber": "เลขที่รับตรวจ",
      "bodyRegion": "บริเวณร่างกาย",
      "studyInstanceUid": "Study Instance UID",
      "cardiologyMeasurements": "ค่าที่วัดได้",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "กำลังโหลดผลตรวจ…",
    "loadError": "โหลดผลตรวจไม่สำเร็จ โปรดลองอีกครั้ง",
    "empty": "ไม่พบผลตรวจตามตัวกรองที่เลือก",
    "toast": {
      "acknowledgeSuccess": "รับทราบค่าวิกฤตแล้ว",
      "acknowledgeError": "รับทราบผลตรวจไม่สำเร็จ"
    },
    "susceptibility": {
      "title": "เชื้อและความไวต่อยา",
      "antibiotic": "ยาปฏิชีวนะ",
      "interpretation": "การแปลผล",
      "mic": "MIC",
      "unnamedOrganism": "เชื้อที่ไม่ระบุชื่อ",
      "noPanel": "ไม่มีผลความไวต่อยาสำหรับเชื้อนี้"
    },
    "components": {
      "value": "ค่าผล",
      "referenceRange": "ค่าอ้างอิง"
    }
  },
  "pending": {
    "title": "ผลตรวจที่รออยู่",
    "countBadge_one": "รอ {{count}} รายการ",
    "countBadge_other": "รอ {{count}} รายการ",
    "autoRefresh": "รีเฟรชอัตโนมัติ {{seconds}} วินาที",
    "updated": "อัปเดต {{when}}",
    "searchPlaceholder": "ค้นหาด้วยชื่อผู้ป่วย, MRN หรือคำสั่ง…",
    "filtersButton": "ตัวกรอง",
    "fields": {
      "orderType": "ประเภทคำสั่ง",
      "allTypes": "ทุกประเภท",
      "priority": "ระดับความเร่งด่วน",
      "allPriorities": "ทุกระดับ",
      "dateFrom": "ตั้งแต่วันที่",
      "dateTo": "ถึงวันที่"
    },
    "orderType": {
      "lab": "ห้องปฏิบัติการ",
      "imaging": "ภาพวินิจฉัย",
      "procedure": "หัตถการ",
      "consultation": "ปรึกษา",
      "laboratory": "ห้องปฏิบัติการ",
      "radiology": "รังสีวิทยา",
      "surgery": "ศัลยกรรม",
      "therapy": "การบำบัด",
      "medication": "ยา",
      "admission": "การรับเข้ารักษา"
    },
    "aria": {
      "dateFrom": "ผลที่รอ ตั้งแต่วันที่",
      "dateTo": "ผลที่รอ ถึงวันที่"
    },
    "columns": {
      "patient": "ผู้ป่วย",
      "mrn": "MRN",
      "order": "คำสั่ง",
      "type": "ประเภท",
      "orderedBy": "ผู้สั่ง",
      "ordered": "เวลาสั่ง",
      "expected": "เวลาที่คาด",
      "priority": "ความเร่งด่วน"
    },
    "loading": "กำลังโหลดผลที่รอ…",
    "loadError": "โหลดผลที่รอไม่สำเร็จ",
    "retry": "ลองอีกครั้ง",
    "empty": "ไม่มีผลตรวจที่รออยู่",
    "awaitingResult": "รอผล",
    "specimenReceived": "รับตัวอย่างแล้ว",
    "inLab": "กำลังตรวจ",
    "cancelledByLab": "ห้องแล็บยกเลิก",
    "overdue": "เกินกำหนด",
    "expectedBy": "คาดว่าภายใน {{date}}"
  },
  "critical": {
    "title": "ผลตรวจวิกฤต",
    "autoRefresh": "รีเฟรชอัตโนมัติ {{seconds}} วินาที",
    "updated": "อัปเดต {{when}}",
    "unacknowledgedHeading_one": "ค่าวิกฤตยังไม่รับทราบ {{count}} รายการ",
    "unacknowledgedHeading_other": "ค่าวิกฤตยังไม่รับทราบ {{count}} รายการ",
    "escalationBanner": "ผลเหล่านี้ต้องให้แพทย์รับทราบโดยทันที",
    "acknowledgeWithinMinutes": "รับทราบภายใน {{minutes}} นาที",
    "routeBackToProvider": "ส่งกลับแพทย์ผู้สั่ง",
    "attendingSignoff": "ต้องให้แพทย์ผู้รับผิดชอบลงนาม",
    "searchPlaceholder": "ค้นหาด้วยผู้ป่วยหรือชื่อรายการตรวจ…",
    "showAcknowledgedToggle": "แสดงที่รับทราบแล้ว",
    "escalationTime": "T+{{minutes}} นาที",
    "criticalFallback": "วิกฤต",
    "loading": "กำลังโหลดผลตรวจวิกฤต…",
    "loadError": "โหลดผลตรวจวิกฤตไม่สำเร็จ",
    "empty": "ไม่มีผลตรวจวิกฤตที่รอการรับทราบ",
    "detailToggleLabel": "แสดงรายละเอียดผล",
    "openFullChart": "เปิดแฟ้มผู้ป่วยฉบับเต็ม",
    "columns": {
      "patient": "ผู้ป่วย",
      "mrn": "MRN",
      "test": "รายการตรวจ",
      "value": "ค่า",
      "impression": "การแปลผล",
      "resultTime": "เวลาผลตรวจ",
      "escalation": "เวลาผ่านไป",
      "acknowledged": "รับทราบ",
      "actions": "การจัดการ"
    },
    "actions": {
      "acknowledge": "รับทราบ"
    },
    "toast": {
      "acknowledgeSuccess": "รับทราบค่าวิกฤตแล้ว",
      "acknowledgeError": "รับทราบผลตรวจไม่สำเร็จ"
    },
    "refreshFailed": "รีเฟรชไม่ได้ — กำลังแสดงผลวิกฤต ณ {{when}}",
    "incomplete": "แสดง {{shown}} จาก {{total}} ผลวิกฤต รายการนี้ไม่ครบถ้วน"
  },
  "acknowledged": {
    "pending": "รอการรับทราบ",
    "acknowledged": "รับทราบแล้ว",
    "escalated": "ส่งต่อแล้ว",
    "expired": "หมดเวลาการรับทราบ"
  },
  "flowsheet": {
    "analyte": "รายการตรวจ",
    "empty": "ไม่มีรายการตรวจทางห้องปฏิบัติการให้แสดงแนวโน้ม",
    "emptyHint": "รายงานภาพวินิจฉัย พยาธิวิทยา และจุลชีววิทยา แสดงในมุมมองไทม์ไลน์",
    "trend": {
      "toggle": "แนวโน้ม {{analyte}}",
      "referenceRange": "ค่าอ้างอิง {{range}}",
      "nonNumericOmitted_one": "ไม่ได้แสดงผลลัพธ์ข้อความ {{count}} รายการ",
      "nonNumericOmitted_other": "ไม่ได้แสดงผลลัพธ์ข้อความ {{count}} รายการ"
    }
  }
}
